import connect from '@elab/core/store/connect';
import { actions as userActions } from '@elab/core/store/user';
import { Dialog } from '@elab/components/common/Dialog';
import { actions as uiActions, selectors as uiSelectors } from '@elab/core/store/ui';

export class PrivacyDialog extends Dialog {
    handleSuccess(evt) {
        evt.stopPropagation();
        this.dispatchEvent(new Event('close'));
        this.dispatchEvent(new Event('privacy-dialog-api-success'));
    }
}

const mapStateToProps = (state, ctx) => ({
    open: uiSelectors.getDialogState(state, ctx.name),
});

const mapDispatchToEvents = dispatch => ({
    'privacy-dialog-api-success': () => dispatch(userActions.acceptPrivacyPolicy()),
    open: ({ detail }) => dispatch(uiActions.openDialog(detail)),
    close: () => dispatch(uiActions.closeDialog()),
});

export default () =>
    customElements.define(
        'e2-privacy-dialog',
        connect(mapStateToProps, mapDispatchToEvents)(PrivacyDialog),
    );
